const organizationDetails = {
  namespaced: true,
  state: {
    logoImage: "",
  },
  mutations: {
    updateOrganizationLogo(state, newLogo) {
        state.logoImage = newLogo;
    },
  },
  actions: {
    getLogo(context) {
        return new Promise((resolve, reject) => {
            this._vm.$traveller_http.get('/traveller/restui/organizations/logo')
                .then(response => {
                    if (response.status == 200 && response.data?.logo ) {
                        context.commit('updateOrganizationLogo', response.data.logo);
                        resolve(response.data.logo)
                    } else {
                        reject()
                    }
                })
                .catch(error => {
                    reject(error)
                })
        });
    }
  },
}

export default organizationDetails